<div class="core-page">
    <app-header [scrollDistance]="scrollDistance"></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-social-links></app-social-links>
</div>
